import "./Card.scss";

function Card({ card, onClick }) {
    return (
        <div className="card-wrapper" onClick={onClick}>
            {
                card.file_type === "photo" ? <img className="card-image" src={card.file_url} alt="Card"/> :
                <video 
                    className="card-video"
                    autoPlay
                    loop
                    muted
                    playsInline
                    disablePictureInPicture
                    controls={false}
                >
                    <source src={card.file_url} type="video/mp4" />
                </video>
            }
        </div>
    )
}

export default Card;